import { DataQueriesContext } from '../runtime/DataQueriesProvider';

function createMockDataQueriesContext(loading: boolean = false) {
  return {
    queryResults: [],
    queryKey: 'test-query-key',
    refetchAll: jest.fn(),
    isFetching: loading,
    isFetchingMore: loading,
    isLoading: loading,
    errors: [],
    queryMode: 'active' as const,
    id: 'test-id',
    cancelInProgressDataQueries: jest.fn(),
  };
}

/*
 * Test component to provide a DataQueriesContext with minimal user setup for testing
 */
export const TestDataQueriesContext = ({
  children,
  loading = false,
}: {
  children: React.ReactNode;
  loading?: boolean;
}) => {
  return (
    <DataQueriesContext.Provider value={createMockDataQueriesContext(loading)}>{children}</DataQueriesContext.Provider>
  );
};
